module.exports = __webpack_public_path__ + "fonts/800-italic-latin-ext.69c1174.woff2";